import { RouterProvider } from "react-router-dom";
import router from "./navigations/Router";
import { Toaster } from "sonner";

const App = () => {
  return (
    <>
      <RouterProvider router={router} />
      <Toaster position="top-right" />
    </>
  );
};

export default App;

// import { useState } from "react";
// import Header from "./components/Header";
// import HeroSection from "./pages/Home/components/HeroSection";
// import AirdropsSection from "./pages/Home/components/AirdropsSection";
// import FeaturesSection from "./pages/Home/components/FeaturesSection";
// import Footer from "./components/Footer";
// import Dashboard from "./components/Dashboard";
// import Home from "./pages/Home/Home";
// // import "./styles/globals.css";

// export default function App() {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);

//   // Handle wallet connection from any part of the landing page
//   const handleLaunchApp = () => {
//     setIsAuthenticated(true);
//   };

//   // If user is authenticated, show dashboard
//   if (isAuthenticated) {
//     return <Dashboard />;
//   }

//   // Show public landing page
//   return (
//     <div className="min-h-screen bg-black text-white">
//       <Header onLaunchApp={handleLaunchApp} />
//       <main>
//         <Home />
//       </main>
//       <Footer />
//     </div>
//   );
// }
